<template>
  <div
    v-if="
      props.status == 'COMPLETE' &&
      props.type != 'PF_CC' &&
      props.type != 'EP_CC' &&
      props.type != 'CR_SL' &&
      !props.pfExpired
    "
    :class="border ? 'uploaded-file' : 'uploaded-file-noBorder'"
  >
    <div class="row align-items-center">
      <div class="col-10">
        <div class="upgrade-to-advance">
          <img src="../../../../svg/pdfLogo.png" alt="My Happy SVG" />
          <label class="fileName">{{
            t("ccOnBoarding.uploadDocument.frontDoc")
          }}</label>
        </div>
      </div>
      <div class="col-2"></div>
    </div>
  </div>
  <div
    v-if="
      props.status == 'COMPLETE' && props.type == 'CR_SL' && props.completedInCC
    "
    :class="border ? 'uploaded-file' : 'uploaded-file-noBorder'"
  >
    <div class="row align-items-center">
      <div class="col-10 mos">
        <div class="upgrade-to-advance">
          <img src="../../../../svg/pdfLogo.png" alt="My Happy SVG" />
          <label class="fileName">{{
            t("ccOnBoarding.uploadDocument.frontDoc")
          }}</label>
        </div>
      </div>
      <div class="col-2 mos" style="display: flex">
        <div
          v-if="props.hideInSummary"
          class="viewFile"
          @click="viewFile(-1, '', true, false, false)"
        >
          {{ t("ccOnBoarding.uploadDocument.view") }}
        </div>
      </div>
    </div>
  </div>
  <div
    v-if="
      props.status == 'COMPLETE' &&
      props.type != 'PF_CC' &&
      props.type != 'EP_CC' &&
      props.type != 'CR_SL' &&
      !props.pfExpired
    "
    :class="border ? 'uploaded-file' : 'uploaded-file-noBorder'"
  >
    <div class="row align-items-center">
      <div class="col-10">
        <div class="upgrade-to-advance">
          <img src="../../../../svg/pdfLogo.png" alt="My Happy SVG" />
          <label class="fileName">{{
            t("ccOnBoarding.uploadDocument.backDoc")
          }}</label>
        </div>
      </div>
      <div class="col-2"></div>
    </div>
  </div>
  <div
    v-if="
      props.status == 'COMPLETE' && props.type == 'CR_SL' && props.completedInCC
    "
    :class="border ? 'uploaded-file' : 'uploaded-file-noBorder'"
  >
    <div class="row align-items-center">
      <div class="col-10 mos">
        <div class="upgrade-to-advance">
          <img src="../../../../svg/pdfLogo.png" alt="My Happy SVG" />
          <label class="fileName">{{
            t("ccOnBoarding.uploadDocument.backDoc")
          }}</label>
        </div>
      </div>
      <div class="col-2 mos" style="display: flex">
        <div
          v-if="props.hideInSummary"
          class="viewFile"
          @click="viewFile(-1, '', false, true, false)"
        >
          {{ t("ccOnBoarding.uploadDocument.view") }}
        </div>
      </div>
    </div>
  </div>

  <div
    v-if="props.mosIdentityFile && props.mosIdentityFile.fileNumber > 0"
    v-for="(d, i) in props.mosIdentityFile.fileName"
    :key="i"
  >
    <div
      v-if="!isEditing(i)"
      :class="[
        border ? 'uploaded-file' : 'uploaded-file-noBorder',
        props.mosIdentityFile.invalidFile[i] ? 'error-border' : '',
      ]"
    >
      <div class="row align-items-center">
        <div class="col-10 mos">
          <div class="upgrade-to-advance">
            <img src="../../../../svg/pdfLogo.png" alt="My Happy SVG" />
            <label class="fileName">{{ d }}</label>
          </div>
        </div>
        <div class="col-2 mos" style="display: flex">
          <div
            v-if="props.hideInSummary"
            class="viewFile"
            :class="props.mosIdentityFile.invalidFile[i] ? 'line' : ''"
            @click="viewFile(i, d, false, false, true)"
          >
            {{ t("ccOnBoarding.uploadDocument.view") }}
          </div>
          <div
            v-if="props.mosIdentityFile.invalidFile[i]"
            class="your-memberships2"
            style="flex: 1"
            @click="removeMOSFile(i, true)"
          >
            <img src="../../../../svg/buttonDelete.svg" alt="My Happy SVG" />
          </div>
        </div>
      </div>
    </div>
  </div>

  <div
    v-if="props.mosIncomeFile && props.mosIncomeFile.fileNumber > 0"
    v-for="(d, i) in props.mosIncomeFile.fileName"
    :key="i"
  >
    <div
      v-if="!isEditing(i)"
      :class="[
        border ? 'uploaded-file' : 'uploaded-file-noBorder',
        props.mosIncomeFile.invalidFile[i] ? 'error-border' : '',
      ]"
    >
      <div class="row align-items-center">
        <div class="col-10 mos">
          <div class="upgrade-to-advance">
            <img src="../../../../svg/pdfLogo.png" alt="My Happy SVG" />
            <label class="fileName">{{ d }}</label>
          </div>
        </div>
        <div class="col-2 mos" style="display: flex">
          <div
            v-if="props.hideInSummary"
            class="viewFile line"
            @click="viewFile(i, d, false, false, true)"
          >
            {{ t("ccOnBoarding.uploadDocument.view") }}
          </div>
          <div
            v-if="deletes && d != 'Personal Financing Documents'"
            class="your-memberships2"
            style="flex: 1"
            @click="removeMOSFile(i, false)"
          >
            <img src="../../../../svg/buttonDelete.svg" alt="My Happy SVG" />
          </div>
        </div>
      </div>
    </div>
  </div>

  <div
    v-if="props.thirdPartyFile && props.thirdPartyFile.fileNumber > 0"
    v-for="(d, i) in props.thirdPartyFile.fileName"
    :key="i"
  >
    <div
      v-if="!isEditing(i)"
      :class="[
        border ? 'uploaded-file' : 'uploaded-file-noBorder',
        props.thirdPartyFile.invalidFile[i] ? 'error-border' : '',
      ]"
    >
      <div class="row align-items-center">
        <div class="col-10">
          <div class="upgrade-to-advance">
            <img src="../../../../svg/pdfLogo.png" alt="My Happy SVG" />
            <label class="fileName">{{ d }}</label>
          </div>
        </div>
        <div class="col-2" style="display: flex">
          <div
            v-if="props.thirdPartyFile.invalidFile[i]"
            class="your-memberships2"
            style="flex: 1"
            @click="removeThirdPartyFile(i)"
          >
            <img src="../../../../svg/buttonDelete.svg" alt="My Happy SVG" />
          </div>
        </div>
      </div>
    </div>
  </div>

  <div
    v-if="
      props.status != 'COMPLETE' ||
      props.type == 'PF_CC' ||
      props.type == 'EP_CC' ||
      props.pfExpired ||
      props.type == 'CR_SL'
    "
    v-for="(d, i) in fileName"
    :key="i"
  >
    <div
      v-if="!isEditing(i)"
      :class="[
        border ? 'uploaded-file' : 'uploaded-file-noBorder',
        props.question.invalidFile[i] ? 'error-border' : '',
      ]"
    >
      <div v-if="props.type == 'CR_SL'" class="row align-items-center">
        <div class="col-10 mos">
          <div class="upgrade-to-advance">
            <img src="../../../../svg/pdfLogo.png" alt="My Happy SVG" />
            <template v-if="i < props.question.resumeFileNumber">
              <label class="fileName">{{ formatFileName(d) }}</label>
            </template>
            <template v-else>
              <label class="fileName">{{ d }}</label>
            </template>
          </div>
        </div>
        <div v-if="props.hideInSummary" class="col-2 mos" style="display: flex">
          <div
            class="viewFile line"
            @click="viewFile(i, d, false, false, false)"
          >
            {{ t("ccOnBoarding.uploadDocument.view") }}
          </div>
          <div class="your-memberships2" style="flex: 1" @click="removeFile(i)">
            <img src="../../../../svg/buttonDelete.svg" alt="My Happy SVG" />
          </div>
        </div>
      </div>
      <div v-else class="row align-items-center">
        <div class="col-10">
          <div class="upgrade-to-advance">
            <img src="../../../../svg/pdfLogo.png" alt="My Happy SVG" />
            <template v-if="i < props.question.resumeFileNumber">
              <label class="fileName">{{ formatFileName(d) }}</label>
            </template>
            <template v-else>
              <label class="fileName">{{ d }}</label>
            </template>
          </div>
        </div>
        <div class="col-2" style="display: flex">
          <div
            v-if="deletes && d != 'Personal Financing Documents'"
            class="your-memberships2"
            style="flex: 1"
            @click="removeFile(i)"
          >
            <img src="../../../../svg/buttonDelete.svg" alt="My Happy SVG" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref, type PropType, computed } from "vue";
import i18n from "@/plugin/i18n";
import type {
  ProofIdentityFile,
  ProofIncomeFile,
  AdditionalFile,
  ProofJCKLFile,
} from "@/interface/FormCC";
import type { SendBackFile1 } from "@/interface/FormCCSendBack";
import MasterService from "@/service/restfulService/CCOnboardMasterService";
import Apis from "@/service/restfulService/Apis";
import heic2any from "heic2any";

const emit = defineEmits(["editData", "updateDataList", "closeApplyForm"]);

let editForm = ref(false);
let indexNumber = ref();
const { t } = i18n.global;

const props = defineProps({
  question: {
    type: Object as PropType<
      | ProofIdentityFile
      | ProofIncomeFile
      | AdditionalFile
      | SendBackFile1
      | ProofJCKLFile
    >,
    required: true,
  },
  webFormRequestId: {
    type: String,
  },
  questionProp: {
    type: String,
  },
  deletes: {
    type: Boolean,
    default: true,
  },
  border: {
    type: Boolean,
    default: true,
  },
  status: {
    type: String,
  },
  type: {
    type: String,
  },
  pfExpired: {
    type: Boolean,
  },
  filePath: {
    type: String,
  },
  completedInCC: {
    type: Boolean,
    default: false,
  },
  isSupplementary: {
    type: Boolean,
    default: false,
  },
  mosIdentityFile: {
    type: Object as PropType<ProofIdentityFile>,
  },
  mosIncomeFile: {
    type: Object as PropType<ProofIncomeFile>,
  },
  thirdPartyFile: {
    type: Object as PropType<ProofIdentityFile | ProofIncomeFile>,
  },
  hideInSummary: {
    type: Boolean,
    default: true,
  },
  uploadFileValidity: {
    type: Object,
  },
  fileType: {
    type: String,
  },
});

const fileName = ref(props.question.fileName);

const file = ref(props.question.file);

const truncatedFileNames = computed(() => {
  return fileName.value.map((name) => {
    const extension = name.split(".").pop();
    const truncatedName = name.length > 4 ? name.substring(0, 12) + ".." : name;
    return (
      truncatedName.substring(0, truncatedName.lastIndexOf(".")) +
      ".." +
      extension
    ); // Append '...' and the file extension
  });
});

const isEditing = (index: number) => {
  return editForm.value && indexNumber.value === index;
};

const formatFileName = (file: string) => {
  // Regular expression to match a UUID
  const uuidRegex =
    /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/;

  // Split the file string and check if the first part matches the UUID format
  const parts = file.split("_");
  if (uuidRegex.test(parts[0])) {
    // If the first part is a valid UUID, run the transformation
    return parts.slice(1).join("_");
  } else {
    // If the first part is not a valid UUID, return the original file
    return file;
  }
};

const removeFile = (index: number) => {
  if (index < props.question.resumeFileNumber) {
    props.question.resumeDeletedFile.push(fileName.value[index]);
    props.question.resumeFileNumber -= 1;
  }
  fileName.value.splice(index, 1);
  file.value.splice(index, 1);
  props.question.invalidFile.splice(index, 1);
  props.question.fileNumber = props.question.fileName.length;
  emit("updateDataList", fileName.value);

  // Check if all files are valid
  let allFilesValid = true;
  for (let i = 0; i < props.question.fileNumber; i++) {
    if (props.question.invalidFile[i]) {
      allFilesValid = false;
      break;
    }
  }

  if (allFilesValid && props.uploadFileValidity) {
    if (props.fileType == "identity") {
      props.uploadFileValidity.uploadFile1 = "";
    } else {
      props.uploadFileValidity.uploadFile2 = "";
    }
  }
};

const removeThirdPartyFile = (index: number) => {
  if (props.thirdPartyFile && index < props.thirdPartyFile.resumeFileNumber) {
    props.thirdPartyFile.resumeDeletedFile.push(
      props.thirdPartyFile.fileName[index]
    );
    props.thirdPartyFile.resumeFileNumber -= 1;

    props.thirdPartyFile.fileName.splice(index, 1);
    props.thirdPartyFile.file.splice(index, 1);
    props.thirdPartyFile.invalidFile.splice(index, 1);
    props.thirdPartyFile.fileNumber = props.thirdPartyFile.fileName.length;
    emit("updateDataList", props.thirdPartyFile.fileName);

    // Check if all files are valid
    let allFilesValid = true;
    for (let i = 0; i < props.thirdPartyFile.fileNumber; i++) {
      if (props.thirdPartyFile.invalidFile[i]) {
        allFilesValid = false;
        break;
      }
    }

    if (allFilesValid && props.uploadFileValidity) {
      if (props.fileType == "identity") {
        props.uploadFileValidity.uploadFile1 = "";
      } else {
        props.uploadFileValidity.uploadFile2 = "";
      }
    }
  }
};

const removeMOSFile = (index: number, identityFile: boolean) => {
  const targetFile = identityFile ? props.mosIdentityFile : props.mosIncomeFile;

  if (targetFile && targetFile.fileNumber > 0) {
    // Track deleted file if it's part of the resume files
    if (index < targetFile.resumeFileNumber) {
      targetFile.resumeDeletedFile.push(targetFile.fileName[index]);
      targetFile.resumeFileNumber -= 1;
    }

    // Remove file-related data at given index
    targetFile.fileName.splice(index, 1);
    targetFile.file.splice(index, 1);
    targetFile.invalidFile.splice(index, 1);

    // Update file count
    targetFile.fileNumber = targetFile.fileName.length;

    // Emit updated file name list
    emit("updateDataList", targetFile.fileName);

    // Check if all files are valid
    let allFilesValid = true;
    for (let i = 0; i < targetFile.fileNumber; i++) {
      if (targetFile.invalidFile[i]) {
        allFilesValid = false;
        break;
      }
    }

    if (allFilesValid && props.uploadFileValidity) {
      if (identityFile) {
        props.uploadFileValidity.ThirdPartyUploadIdentityFileValidity = "";
      } else {
        props.uploadFileValidity.ThirdPartyUploadIncomeFileValidity = "";
      }
    }
  } else if (props.uploadFileValidity) {
    if (identityFile) {
      props.uploadFileValidity.ThirdPartyUploadIdentityFileValidity = "";
    } else {
      props.uploadFileValidity.ThirdPartyUploadIncomeFileValidity = "";
    }
  }
};

const viewFile = (
  index: number,
  fileName: string,
  isFrontDoc: Boolean,
  isBackDoc: Boolean,
  mosFile: Boolean
) => {
  if (
    !(index < props.question.resumeFileNumber) &&
    !isFrontDoc &&
    !isBackDoc &&
    !mosFile
  ) {
    const file = props.question.file[index].get("file");
    if (file instanceof Blob) {
      const fileURL = URL.createObjectURL(file);
      const newTab = window.open(fileURL, "_blank"); // Open the file in a new tab
      if (newTab) {
        newTab.focus(); // Focus on the new tab if it opens successfully
      }
    }
  } else {
    const newTab = window.open("", "_blank");
    const requestModel = {
      webFormRequestId: props.webFormRequestId,
      fileName: fileName,
      ekycFrontDoc: isFrontDoc,
      ekycBackDoc: isBackDoc,
      principalDoc: props.isSupplementary ? false : true,
      suppDoc: props.isSupplementary ? true : false,
    };

    MasterService.getFile(requestModel)
      .then((res) => {
        const contentType = res.headers["content-type"] || "";
        if (res.data.byteLength > 0 && contentType != "") {
          const blob = new Blob([res.data], {
            type: contentType,
          });

          if (contentType == "image/heif" || contentType == "image/heic") {
            heic2any({ blob, toType: "image/jpeg" }).then((converted) => {
              // Handle both Blob and Blob[]
              const convertedBlob = Array.isArray(converted)
                ? converted[0]
                : converted;
              // const url = URL.createObjectURL(convertedBlob);
              if (newTab) {
                newTab.location.href = URL.createObjectURL(convertedBlob); // Now browser can display it
              }
            });
          } else {
            // const url = URL.createObjectURL(blob);
            if (newTab) {
              newTab.location.href = URL.createObjectURL(blob); // Now browser can display it
            }
          }
        } else {
          if (newTab) {
            newTab.document.body.innerHTML = "No image available.";
          }
        }
      })
      .catch((e) => {
        if (newTab) {
          newTab.document.body.innerHTML = "No image available.";
        }
      });
  }
};
</script>

<style scoped>
.col-2 {
  text-align: center;
  padding: 0;
}

@media (max-width: 900px) {
  .col-2.mos {
    width: 33.33%;
  }

  .col-10.mos {
    width: 66.67%;
  }
}

.fileList {
  margin-top: 20px;
}

.uploaded-file {
  background: var(--white-high-100, #ffffff);
  border-radius: 10px;
  border-style: solid;
  border-color: var(--line-break, #ac2887);
  border-width: 1.5px;
  padding: 12px 16px 12px 16px;
  margin-top: 8px;
}

.error-border {
  border-color: var(--line-break, red) !important;
}

.uploaded-file-noBorder {
  background: var(--white-high-100, #ffffff);
  padding: 10px 16px 12px 0;
}

.upgrade-to-advance {
  display: flex;
  align-items: center;
  color: var(--black-high-87, rgba(0, 0, 0, 0.87));
  text-align: left;
  font: var(--subtitle-1-medium, 500 16px/130% "Outfit", sans-serif);
  position: relative;
  align-self: stretch;
}

.fileName {
  flex: 1;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  margin: 0 0 0 12px;
  color: var(--black-high-87, rgba(0, 0, 0, 0.87));
  font: var(--subtitle-1-medium, 500 16px/130% "Outfit", sans-serif);
}

.your-memberships2 {
  display: flex;
  justify-content: center;
}

.viewFile {
  flex: 1;

  color: #cb03bc;
  cursor: default;
}

.viewFile.line {
  border-right: 1.5px solid #ac2887;
}
</style>
